import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import ServiceCategoryDataGrid from './ServiceCategoryDataGrid';
import { RootState } from 'store';
import { FastField, useFormikContext } from 'formik';
import { TextField } from 'formik-material-ui';
import { FORM_MODE } from 'shared/enums';
import { IStrategyRegister } from '../interfaces';

const ServiceCategoryList: React.FC = () => {
  const {
    list: { serviceCategories },
  } = useSelector((state: RootState) => state.parameters);

  const { mode } = useSelector(
    (state: RootState) => state.selectedStrategyModeNavigation,
  );

  const isViewOnly = mode === FORM_MODE.view;

  const { values: strategy } = useFormikContext<IStrategyRegister>();

  const isEditingSimulationReady =
    mode === FORM_MODE.edit && strategy.status === 'SIMULATION_READY';

  return (
    <Grid container direction="column">
      <Grid
        item
        container
        xs={12}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Grid item xs={12}>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="stretch"
            >
              <Grid item>
                <Typography
                  data-cy="service-category-list__label--strategy-name"
                  variant="h6"
                >
                  Nome da Estratégia
                </Typography>
              </Grid>
              <FastField
                data-cy="service-category-list__input--strategy-name"
                component={TextField}
                fullWidth
                name="name"
                disabled={isViewOnly || isEditingSimulationReady}
              />
            </Grid>
            <Grid container direction="column" justifyContent="flex-start">
              <Grid item>
                <Typography
                  data-cy="service-category-list__label--strategy-executionPeriodicityInDays"
                  variant="h6"
                >
                  Periodicidade de execução da régua
                </Typography>
              </Grid>
              <Grid item>
                <FastField
                  type="number"
                  data-cy="service-category-list__input--strategy-executionPeriodicityInDays"
                  component={TextField}
                  name="executionPeriodicityInDays"
                  disabled={isViewOnly || isEditingSimulationReady}
                />
              </Grid>
            </Grid>
            {serviceCategories.map((category) => (
              <Grid item xs={12} key={category._id}>
                <ServiceCategoryDataGrid
                  serviceCategory={category}
                  isViewOnly={isViewOnly}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ServiceCategoryList;
